// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3IidR","tab":"ProcedureTabs_tab__hhn0R"};